/**
 * Atajo para abrir el panel de buscar por foto desde cualquier parte del sitio.
 *
 * El panel vive dentro del buscador de la cabecera (rediseño del 14-09-2026:
 * ya no hay pantalla `/buscar/foto`), y la pagina de resultados sin nada
 * quiere ofrecerlo como salida. Es un evento del documento y no un contexto de
 * React porque son dos lugares que no comparten nada mas, y cablear un
 * proveedor para un solo boton seria mas codigo que el problema.
 */

const NOMBRE = 'elcarpintero:buscar-por-foto';

export function pedirBusquedaPorFoto(): void {
  document.dispatchEvent(new CustomEvent(NOMBRE));
}

/** Devuelve la funcion que deja de escuchar. */
export function alPedirBusquedaPorFoto(escucha: () => void): () => void {
  document.addEventListener(NOMBRE, escucha);
  return () => document.removeEventListener(NOMBRE, escucha);
}
